import { Button, Result, Typography } from 'antd';
import { message } from '@/components/Message';
import React, { ErrorInfo } from 'react';
import api from '../../api';
import { ReloadOutlined } from '@ant-design/icons';
import { APIError } from '../../api/types';

export const apiErrorHandler = (error: APIError) => {
  const msg = error.msg || error.message;
  const codeTip = error.code ? `，错误码: ${error.code}` : '';
  const statusTip = error.status ? `，状态码: ${error.status}` : '';
  if (msg) {
    message.error(
      <Typography.Text copyable={{ text: `${msg}${codeTip}${statusTip}` }}>
        出错了: {msg}
        {codeTip}
        {/* {statusTip} */}
      </Typography.Text>
    );
  }
};

window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  const reason = e.reason as APIError;
  apiErrorHandler(reason);
  console.error('Promise 异常:', e);
});

type Props = {
  children: React.ReactNode;
};
type State = {
  errorInfo: ErrorInfo;
  error: Error;
  pending: boolean;
};

class PosErrorBoundary extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, pending: false };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    api
      .post({
        url: `/error/pos`,
        data: {
          path: location.href,
          message: error ? error.message : '无内容',
          stack: errorInfo ? errorInfo.componentStack : '无内容',
        },
      })
      .then();
  }

  render() {
    const { errorInfo, error, pending } = this.state;
    if (errorInfo) {
      return (
        <Result
          status="500"
          title="系统出错啦"
          subTitle={
            <>
              <Typography.Paragraph>抱歉，系统出现了异常</Typography.Paragraph>
              <Typography.Paragraph>我们将尽快修复该问题，建议重启应用后再试</Typography.Paragraph>
              <Typography.Paragraph>
                <Button
                  icon={<ReloadOutlined />}
                  loading={pending}
                  type="primary"
                  size={'large'}
                  onClick={() => {
                    this.setState({
                      pending: true,
                    });
                    window.location.reload();
                  }}>
                  立即重启
                </Button>
              </Typography.Paragraph>
              <Typography.Paragraph>{error.message}</Typography.Paragraph>
              <Typography.Paragraph>{errorInfo.componentStack}</Typography.Paragraph>
            </>
          }
          // extra={
          //   <Button
          //     type="primary"
          //     onClick={() => {
          //       window.location.reload();
          //     }}>
          //     重启
          //   </Button>
          // }
        />
      );
    }
    return this.props.children;
  }
}

export default PosErrorBoundary;
